import { useState } from "react";
import { Button, Col, FormControl, FormLabel, Row, Spinner } from "react-bootstrap";
import Validator from "../../../services/Validator";
import PrivateApi from "../../../services/PrivateApiService";
import { FaCheck } from "react-icons/fa";
import { useAuthDispatch } from "../../../context/AuthContext";

const AccountView = ({ user, loggedUser }) => {

    const API = new PrivateApi();
    const VALIDATOR = new Validator();
    const dispatch = useAuthDispatch(); // use auth context to dispatch commands
    const [loginEmail, setLoginEmail] = useState(user.x_qr_login);
    const [pass1, setPass1] = useState("");
    const [pass2, setPass2] = useState("");
    const [fieldErrors, setFieldErrors] = useState({});
    const [state, setState] = useState("default");


    const changeData = () => {
        setFieldErrors({});
        // checks 
        let temp = {};
        if (loginEmail !== user.x_qr_login && !VALIDATOR.EmailValid(loginEmail)) temp.loginEmail = "Eingegebene E-Mail ist falsch.";
        if (pass1 !== "" && !VALIDATOR.PasswordValid(pass1)) temp.pass1 = "Das Passwort muss mindestens 10 Zeichen lang sein und mindestens eine Ziffer und einen Buchstabe enthalten.";
        if (pass1 !== "" && pass1 !== pass2) temp.pass2 = "Die Passwörter müssen übereinstimmen";

        if (Object.keys(temp).length > 0) {
            return setFieldErrors(temp);
        }

        setState("loading")
        var dataToSend = {}
        if (user.x_qr_login !== loginEmail) dataToSend['x_qr_login'] = loginEmail;

        if (dataToSend['x_qr_login'] === undefined) {
            if (pass1 !== "") dataToSend['x_qr_password'] = pass1;
        }

        API.post_PartnerLoginDataChange(dataToSend)
            .then(() => {
                setState("success");
                dispatch('LOGOUT');
            })
            .catch(() => {
                setState("error");
            });
    }

    return (
        <>
            <Row>
                <h5>Benutzerkonto</h5>
                <p className="text-muted">Ihr Login-Daten für den Einstieg ins Managementportal</p>
                <hr />
            </Row>
            <Row className="mt-3">
                <Col xs="12" md="10" xl="8">
                    <FormLabel>Login E-Mail</FormLabel>
                    <FormControl 
                        placeholder="Login E-Mail" 
                        value={loginEmail} 
                        onChange={e => {setLoginEmail(e.target.value); setFieldErrors({})}}
                        isValid={user.x_qr_login !== loginEmail && VALIDATOR.EmailValid(loginEmail)}
                        isInvalid={fieldErrors.loginEmail}
                    />
                    <small className="text-danger">{fieldErrors.loginEmail}</small>
                </Col>
            </Row>
            {loginEmail !== user.x_qr_login &&
                <p className="text-muted mt-1">
                    <small>
                        <b>Hinweis:</b> Beim Ändern der Login E-Mail-Adresse 
                        verifizieren wir Ihre E-Mail-Adresse erneut. Nach dem 
                        Bestätigen lassen wir Ihnen eine E-Mail zukommen. 
                        Bitte folgen Sie dem Link in der E-Mail und setzen ein 
                        neues Passwort.
                    </small>
                </p>
            }
            <Row className="mt-5" hidden={loggedUser.related_accounts.length > 1 && loggedUser.related_accounts.some(acc => acc.x_is_house_management === true)}>
                <Col xs="12" md="6" xl="6">
                    <FormLabel>Neues Passwort</FormLabel>
                    <FormControl 
                        type="password" 
                        value={pass1} 
                        disabled={loginEmail !== user.x_qr_login}
                        onChange={e => {setPass1(e.target.value); setFieldErrors({})}} 
                        isValid={VALIDATOR.PasswordValid(pass1)}
                        isInvalid={fieldErrors.pass1}
                    />
                    <small className="text-danger">{fieldErrors.pass1}</small>
                </Col>
                <Col xs="12" md="6" xl="6">
                    <FormLabel>Passwort wiederholen</FormLabel>
                    <FormControl 
                        type="password" 
                        value={pass2} 
                        disabled={loginEmail !== user.x_qr_login}
                        onChange={e => {setPass2(e.target.value); setFieldErrors({})}} 
                        isValid={pass1 === pass2 && VALIDATOR.PasswordValid(pass2)}
                        isInvalid={fieldErrors.pass2}
                    />
                    <small className="text-danger">{fieldErrors.pass2}</small>
                </Col>
                <p className="text-muted"><small>Das Passwort muss mindestens 10 Zeichen lang sein und mindestens eine Ziffer und einen Buchstabe enthalten.</small></p>
            </Row>
            <Row className="mt-5">
                <Col className="text-end">
                    {
                        state === "loading"?
                            <><Spinner animation="border" className="text-energo" /></> :
                        state === "error"?
                            <p className="text-danger">Fehler gekommen bei speichern von Ihre Benutzerkonto. Bitte versuchen Sie später erneut.</p> :
                        state === "success"?
                            <p className="text-energo"><FaCheck /> Benutzerkonto geändert!</p> :
                            <Button onClick={() => changeData()} className="btn-energo">Absenden</Button>
                    }
                </Col>
            </Row>
        </>
    )
}
export default AccountView;